import React from "react";
import { Link, NavLink, withRouter } from "react-router-dom";
import {
  FaHome,
  FaBookOpen,
  FaFileAlt,
  FaClipboardList,
  FaBriefcase,
  FaPenNib,
  FaUserCircle,
  FaSignInAlt,
  FaChevronDown
} from "react-icons/fa";

import logo from "./img/erwatodaylogo.png";
import "./cssfile/header.css";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoggedIn: !!(
        localStorage.getItem("email") &&
        localStorage.getItem("password")
      ),
      candidateName:
        localStorage.getItem("name") ||
        localStorage.getItem("username") ||
        localStorage.getItem("candidate_name") ||
        "Candidate",
      mobileMenu: false,
      testSeriesOpen: false
    };
  }

  componentDidMount() {
    window.addEventListener("storage", this.handleStorageChange);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this.handleStorageChange);
  }

  handleStorageChange = () => {
    this.setState({
      isLoggedIn: !!(
        localStorage.getItem("email") &&
        localStorage.getItem("password")
      )
    });
  };

  toggleMobileMenu = () => {
    this.setState(prevState => ({
      mobileMenu: !prevState.mobileMenu
    }));
  };

  toggleTestSeries = () => {
    this.setState(prevState => ({
      testSeriesOpen: !prevState.testSeriesOpen
    }));
  };

  closeMenus = () => {
    this.setState({
      mobileMenu: false,
      testSeriesOpen: false
    });
  };

  getInitial = () => {
    const { candidateName } = this.state;
    return candidateName ? candidateName.charAt(0).toUpperCase() : "C";
  };

  renderNavLink = (to, icon, label) => (
    <NavLink
      exact={to === "/"}
      to={to}
      className="et-nav-link"
      activeClassName="et-nav-link-active"
      onClick={this.closeMenus}
    >
      <span className="et-nav-icon">{icon}</span>
      <span>{label}</span>
    </NavLink>
  );

  render() {
    const {
      isLoggedIn,
      candidateName,
      mobileMenu,
      testSeriesOpen
    } = this.state;

    return (
      <header className="et-header">
        <div className="et-header-inner">

          <Link
            to="/home"
            className="et-brand"
            onClick={this.closeMenus}
          >
            <div className="et-logo-wrapper">
              <img
                src={logo}
                alt="ErwaToday"
                className="et-logo"
              />
            </div>

            <div className="et-brand-text">
              <strong>ErwaToday</strong>
              <span>Learning Portal</span>
            </div>
          </Link>

          <nav className="et-navigation">
            {this.renderNavLink("/home", <FaHome />, "Home")}

            <div
              className={`et-dropdown ${
                testSeriesOpen ? "et-dropdown-open" : ""
              }`}
            >
              <button
                type="button"
                className="et-dropdown-button"
                onClick={this.toggleTestSeries}
              >
                <span className="et-nav-icon">
                  <FaBookOpen />
                </span>

                <span>Test Series</span>

                <FaChevronDown className="et-dropdown-arrow" />
              </button>

              {testSeriesOpen && (
                <div className="et-dropdown-menu">
                  <Link to="/allseries" onClick={this.closeMenus}>
                    <FaBookOpen />
                    <span>All Test Series</span>
                  </Link>

                  <Link
                    to="/question_paper_download"
                    onClick={this.closeMenus}
                  >
                    <FaFileAlt />
                    <span>Question Papers</span>
                  </Link>
                </div>
              )}
            </div>

            {this.renderNavLink(
              "/question_paper",
              <FaFileAlt />,
              "Question Papers"
            )}

            {this.renderNavLink(
              "/mcq_practice",
              <FaClipboardList />,
              "MCQ Practice"
            )}

            {this.renderNavLink(
              "/Job",
              <FaBriefcase />,
              "Latest Jobs"
            )}

            {this.renderNavLink("/blog", <FaPenNib />, "Blog")}
          </nav>

          <div className="et-header-actions">
            {isLoggedIn ? (
              <Link
                to="/profile"
                className="et-profile"
                onClick={this.closeMenus}
              >
                <div className="et-profile-avatar">
                  {this.getInitial()}
                </div>

                <div className="et-profile-info">
                  <strong>{candidateName}</strong>
                  <span>Candidate</span>
                </div>
              </Link>
            ) : (
              <Link
                to="/login"
                className="et-login-button"
                onClick={this.closeMenus}
              >
                <FaSignInAlt />
                <span>Sign In</span>
              </Link>
            )}

            <button
              type="button"
              className="et-mobile-button"
              onClick={this.toggleMobileMenu}
              aria-label="Open menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>

        {mobileMenu && (
          <div className="et-mobile-navigation">
            {this.renderNavLink("/home", <FaHome />, "Home")}

            <Link
              to="/allseries"
              className="et-mobile-link"
              onClick={this.closeMenus}
            >
              <FaBookOpen />
              <span>Test Series</span>
            </Link>

            <Link
              to="/question_paper"
              className="et-mobile-link"
              onClick={this.closeMenus}
            >
              <FaFileAlt />
              <span>Question Papers</span>
            </Link>

            <Link
              to="/mcq_practice"
              className="et-mobile-link"
              onClick={this.closeMenus}
            >
              <FaClipboardList />
              <span>MCQ Practice</span>
            </Link>

            <Link
              to="/Job"
              className="et-mobile-link"
              onClick={this.closeMenus}
            >
              <FaBriefcase />
              <span>Latest Jobs</span>
            </Link>

            <Link
              to="/blog"
              className="et-mobile-link"
              onClick={this.closeMenus}
            >
              <FaPenNib />
              <span>Blog</span>
            </Link>

            {isLoggedIn && (
              <Link
                to="/profile"
                className="et-mobile-profile"
                onClick={this.closeMenus}
              >
                <FaUserCircle />
                <span>My Profile</span>
              </Link>
            )}
          </div>
        )}
      </header>
    );
  }
}

export default withRouter(Header);
